import { render, staticRenderFns } from "./PaymentFormView.vue?vue&type=template&id=d85ee820&scoped=true&"
import script from "./PaymentFormView.vue?vue&type=script&lang=js&"
export * from "./PaymentFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85ee820",
  null
  
)

export default component.exports